import React, { useEffect } from "react";
import "./CardsSection.css";
import { useNavigate } from "react-router-dom";
import { FaMobileAlt, FaGamepad, FaDatabase, FaCloud, FaServer, FaCogs } from "react-icons/fa";

import person1 from "../../assets/images/person1.jpg";
import person2 from "../../assets/images/person2.jpg";
import person3 from "../../assets/images/person3.jpg";
import person4 from "../../assets/images/person4.jpg";

const CardsSection = () => {
  const navigate = useNavigate();

  // ⭐ Smooth scroll animation (slide from top)
  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-anim");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const services = [
    { 
      title: "App Development", 
      icon: <FaMobileAlt />, 
      link: "/services/app-development",
      description: "Our expert team of developers creates high-quality, user-friendly mobile and web applications. Whether it’s iOS, Android, or cross-platform development, we leverage the latest technologies to bring your ideas to life."
    },
    { 
      title: "Game Development", 
      icon: <FaGamepad />, 
      link: "/services/game-development",
      description: "Immerse your audience in captivating and interactive gaming experiences. Our game development experts leverage the latest technologies to craft visually stunning and engaging games for different platforms."
    },
    { 
      title: "Data Science", 
      icon: <FaDatabase />, 
      link: "/services/data-science",
      description: "Our Data Science Services encompass a holistic approach, from data collection and cleansing to advanced analysis and modeling. We create end-to-end solutions that ensure you extract maximum value from your data assets."
    },
    { 
      title: "Data Analysis", 
      icon: <FaCloud />, 
      link: "/services/data-analysis",
      description: "Our Data Analysis Services are designed to turn raw information into actionable insights, empowering your business to thrive in the data-driven era."
    },
    { 
      title: "Business Consulting", 
      icon: <FaServer />, 
      link: "/services/business-consulting",
      description: "Navigate the complexities of the business landscape with our strategic Business Consulting services. We offer tailored solutions to enhance your operations, improve efficiency, and achieve sustainable growth."
    },
    { 
      title: "Cloud Computing", 
      icon: <FaCogs />, 
      link: "/services/data-science",
      description: "Embrace the future of computing with our Cloud Computing solutions. From cloud infrastructure to data storage and security, we enable businesses to leverage the agility and scalability offered by cloud technologies."
    },
  ];

  return (
    <section className="cards-wrapper scroll-anim">

      <h2 className="cards-heading scroll-anim">WHAT WE OFFER</h2>
      <div className="underline scroll-anim"></div>
      <p className="cards-subtext scroll-anim">
        We deliver smart, scalable & modern digital solutions.
      </p>

      <div className="cards-container">
        {services.map((srv, index) => (
          <div key={index} className="card-box scroll-anim">
            <div className="card-icon">{srv.icon}</div>

            <h3>{srv.title}</h3>
            <p>{srv.description}</p>

            <button 
              className="view-btn"
              onClick={() => navigate(srv.link)}
            >
              View More
            </button>
          </div>
        ))}
      </div>

      {/* TRUST BADGE */}
      <div className="trust-badge scroll-anim">
        <div className="trust-avatars">
          <img src={person1} alt="user1" />
          <img src={person2} alt="user2" />
          <img src={person3} alt="user3" />
          <img src={person4} alt="user4" />
        </div>

        <p>
          Trusted by <span>50,000+ businesses</span> to scale outbound sales
        </p>
      </div>

    </section>
  );
};

export default CardsSection;
